module.exports = __webpack_public_path__ + "img/10.5720de07.jpg";